let municipalData = [
  {
    Province: 'EC',
    muni_code: 'BUF',
    Municipality: 'Buffalo City',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '59%',
    ANC: '60',
    DA: '24',
    EEF: '8',
    IFP: '',
    'Other parties': '8',
    'Total council seats available': '100',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '56%',
  },
  {
    Province: 'WC',
    muni_code: 'CPT',
    Municipality: 'City of Cape Town',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '67%',
    ANC: '57',
    DA: '154',
    EEF: '7',
    IFP: '',
    'Other parties': '13',
    'Total council seats available': '231',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '64%',
  },
  {
    Province: 'EC',
    muni_code: 'EC101',
    Municipality: 'Dr Beyers Naudé',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '51%',
    ANC: '14',
    DA: '13',
    EEF: '',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '27',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '61%',
  },
  {
    Province: 'EC',
    muni_code: 'EC102',
    Municipality: 'Blue Crane Route',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '60%',
    ANC: '7',
    DA: '4',
    EEF: '',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '11',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '61%',
  },
  {
    Province: 'EC',
    muni_code: 'EC104',
    Municipality: 'Makana',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '62%',
    ANC: '17',
    DA: '8',
    EEF: '2',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '27',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '52%',
  },
  {
    Province: 'EC',
    muni_code: 'EC105',
    Municipality: 'Ndlambe',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '62%',
    ANC: '13',
    DA: '6',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '20',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '65%',
  },
  {
    Province: 'EC',
    muni_code: 'EC106',
    Municipality: 'Sundays River Valley',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '72%',
    ANC: '11',
    DA: '4',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '16',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '58%',
  },
  {
    Province: 'EC',
    muni_code: 'EC108',
    Municipality: 'Kouga',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '57%',
    ANC: '12',
    DA: '17',
    EEF: '',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '29',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '66%',
  },
  {
    Province: 'EC',
    muni_code: 'EC109',
    Municipality: 'Kou Kamma',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '51%',
    ANC: '6',
    DA: '5',
    EEF: '',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '11',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'EC',
    muni_code: 'EC121',
    Municipality: 'Mbhashe',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '73%',
    ANC: '47',
    DA: '2',
    EEF: '2',
    IFP: '',
    'Other parties': '12',
    'Total council seats available': '63',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'EC',
    muni_code: 'EC122',
    Municipality: 'Mnquma',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '74%',
    ANC: '48',
    DA: '3',
    EEF: '3',
    IFP: '',
    'Other parties': '8',
    'Total council seats available': '62',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '51%',
  },
  {
    Province: 'EC',
    muni_code: 'EC123',
    Municipality: 'Great Kei',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '71%',
    ANC: '9',
    DA: '2',
    EEF: '1',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '13',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '62%',
  },
  {
    Province: 'EC',
    muni_code: 'EC124',
    Municipality: 'Amahlathi',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '76%',
    ANC: '24',
    DA: '3',
    EEF: '3',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '30',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'EC',
    muni_code: 'EC126',
    Municipality: 'Ngqushwa',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '83%',
    ANC: '20',
    DA: '1',
    EEF: '2',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '23',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '57%',
  },
  {
    Province: 'EC',
    muni_code: 'EC129',
    Municipality: 'Raymond Mhlaba',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '78%',
    ANC: '38',
    DA: '5',
    EEF: '3',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '46',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '55%',
  },
  {
    Province: 'EC',
    muni_code: 'EC131',
    Municipality: 'Inxuba Yethemba',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '57%',
    ANC: '11',
    DA: '7',
    EEF: '',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '18',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '57%',
  },
  {
    Province: 'EC',
    muni_code: 'EC135',
    Municipality: 'Intsika Yethu',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '80%',
    ANC: '35',
    DA: '1',
    EEF: '3',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '42',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '58%',
  },
  {
    Province: 'EC',
    muni_code: 'EC136',
    Municipality: 'Emalahleni',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '81%',
    ANC: '28',
    DA: '4',
    EEF: '1',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '34',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'EC',
    muni_code: 'EC137',
    Municipality: 'Engcobo',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '83%',
    ANC: '33',
    DA: '1',
    EEF: '2',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '39',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '52%',
  },
  {
    Province: 'EC',
    muni_code: 'EC138',
    Municipality: 'Sakhisizwe',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '80%',
    ANC: '14',
    DA: '1',
    EEF: '1',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '17',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '55%',
  },
  {
    Province: 'EC',
    muni_code: 'EC139',
    Municipality: 'Enoch Mgijima',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '72%',
    ANC: '50',
    DA: '9',
    EEF: '6',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '68',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'EC',
    muni_code: 'EC141',
    Municipality: 'Elundini',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '84%',
    ANC: '28',
    DA: '2',
    EEF: '1',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '34',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '55%',
  },
  {
    Province: 'EC',
    muni_code: 'EC142',
    Municipality: 'Senqu',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '67%',
    ANC: '23',
    DA: '2',
    EEF: '1',
    IFP: '',
    'Other parties': '8',
    'Total council seats available': '34',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '58%',
  },
  {
    Province: 'EC',
    muni_code: 'EC145',
    Municipality: 'Walter Sisulu',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '65%',
    ANC: '15',
    DA: '5',
    EEF: '1',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '22',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '57%',
  },
  {
    Province: 'EC',
    muni_code: 'EC153',
    Municipality: 'Ingquza Hill',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '84%',
    ANC: '53',
    DA: '2',
    EEF: '4',
    IFP: '',
    'Other parties': '4',
    'Total council seats available': '63',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '52%',
  },
  {
    Province: 'EC',
    muni_code: 'EC154',
    Municipality: 'Port St Johns',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '79%',
    ANC: '31',
    DA: '2',
    EEF: '1',
    IFP: '',
    'Other parties': '5',
    'Total council seats available': '39',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '56%',
  },
  {
    Province: 'EC',
    muni_code: 'EC155',
    Municipality: 'Nyandeni',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '83%',
    ANC: '54',
    DA: '3',
    EEF: '3',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '63',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '51%',
  },
  {
    Province: 'EC',
    muni_code: 'EC156',
    Municipality: 'Mhlontlo',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '77%',
    ANC: '40',
    DA: '2',
    EEF: '2',
    IFP: '',
    'Other parties': '7',
    'Total council seats available': '51',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '53%',
  },
  {
    Province: 'EC',
    muni_code: 'EC157',
    Municipality: 'King Sabata Dalindyebo',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '63%',
    ANC: '46',
    DA: '3',
    EEF: '3',
    IFP: '',
    'Other parties': '20',
    'Total council seats available': '72',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '45%',
  },
  {
    Province: 'EC',
    muni_code: 'EC441',
    Municipality: 'Matatiele',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '74%',
    ANC: '38',
    DA: '5',
    EEF: '3',
    IFP: '',
    'Other parties': '5',
    'Total council seats available': '51',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'EC',
    muni_code: 'EC442',
    Municipality: 'Umzimvubu',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '77%',
    ANC: '41',
    DA: '4',
    EEF: '3',
    IFP: '',
    'Other parties': '5',
    'Total council seats available': '53',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'EC',
    muni_code: 'EC443',
    Municipality: 'Winnie Madikizela_Mandela',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '81%',
    ANC: '50',
    DA: '2',
    EEF: '4',
    IFP: '',
    'Other parties': '6',
    'Total council seats available': '62',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '57%',
  },
  {
    Province: 'EC',
    muni_code: 'EC444',
    Municipality: 'Ntabankulu',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '85%',
    ANC: '29',
    DA: '2',
    EEF: '2',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '34',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'GP',
    muni_code: 'EKU',
    Municipality: 'City of Ekurhuleni',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '49%',
    ANC: '109',
    DA: '77',
    EEF: '25',
    IFP: '2',
    'Other parties': '11',
    'Total council seats available': '224',
    'Council run by': 'ANC coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '58%',
  },
  {
    Province: 'KZN',
    muni_code: 'ETH',
    Municipality: 'eThekwini',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '56%',
    ANC: '126',
    DA: '60',
    EEF: '8',
    IFP: '10',
    'Other parties': '14',
    'Total council seats available': '218',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'FS',
    muni_code: 'FS161',
    Municipality: 'Letsemeng',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '69%',
    ANC: '8',
    DA: '2',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '11',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'FS',
    muni_code: 'FS162',
    Municipality: 'Kopanong',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '70%',
    ANC: '11',
    DA: '3',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '15',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '62%',
  },
  {
    Province: 'FS',
    muni_code: 'FS163',
    Municipality: 'Mohokare',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '65%',
    ANC: '7',
    DA: '2',
    EEF: '2',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '11',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '55%',
  },
  {
    Province: 'FS',
    muni_code: 'FS181',
    Municipality: 'Masilonyana',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '64%',
    ANC: '12',
    DA: '4',
    EEF: '2',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '19',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '58%',
  },
  {
    Province: 'FS',
    muni_code: 'FS182',
    Municipality: 'Tokologo',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '67%',
    ANC: '5',
    DA: '1',
    EEF: '1',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '8',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '63%',
  },
  {
    Province: 'FS',
    muni_code: 'FS183',
    Municipality: 'Tswelopele',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '73%',
    ANC: '11',
    DA: '3',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '15',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'FS',
    muni_code: 'FS184',
    Municipality: 'Matjhabeng',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '63%',
    ANC: '46',
    DA: '16',
    EEF: '6',
    IFP: '',
    'Other parties': '4',
    'Total council seats available': '72',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '55%',
  },
  {
    Province: 'FS',
    muni_code: 'FS185',
    Municipality: 'Nala',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '62%',
    ANC: '15',
    DA: '3',
    EEF: '5',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '24',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '56%',
  },
  {
    Province: 'FS',
    muni_code: 'FS191',
    Municipality: 'Setsoto',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '62%',
    ANC: '21',
    DA: '5',
    EEF: '3',
    IFP: '',
    'Other parties': '4',
    'Total council seats available': '33',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'FS',
    muni_code: 'FS192',
    Municipality: 'Dihlabeng',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '64%',
    ANC: '25',
    DA: '8',
    EEF: '3',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '39',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'FS',
    muni_code: 'FS193',
    Municipality: 'Nketoana',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '71%',
    ANC: '13',
    DA: '3',
    EEF: '1',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '18',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'FS',
    muni_code: 'FS194',
    Municipality: 'Maluti a Phofung',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '68%',
    ANC: '47',
    DA: '5',
    EEF: '9',
    IFP: '',
    'Other parties': '8',
    'Total council seats available': '69',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '53%',
  },
  {
    Province: 'FS',
    muni_code: 'FS195',
    Municipality: 'Phumelela',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '77%',
    ANC: '12',
    DA: '2',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '15',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'FS',
    muni_code: 'FS196',
    Municipality: 'Mantsopa',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '66%',
    ANC: '11',
    DA: '3',
    EEF: '2',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '17',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'FS',
    muni_code: 'FS201',
    Municipality: 'Moqhaka',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '60%',
    ANC: '27',
    DA: '11',
    EEF: '4',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '45',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '53%',
  },
  {
    Province: 'FS',
    muni_code: 'FS203',
    Municipality: 'Ngwathe',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '65%',
    ANC: '24',
    DA: '8',
    EEF: '3',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '36',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'FS',
    muni_code: 'FS204',
    Municipality: 'Metsimaholo',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '45%',
    ANC: '19',
    DA: '12',
    EEF: '8',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '42',
    'Council run by': 'ANC coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '58%',
  },
  {
    Province: 'FS',
    muni_code: 'FS205',
    Municipality: 'Mafube',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '76%',
    ANC: '13',
    DA: '2',
    EEF: '1',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '17',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'GP',
    muni_code: 'GT421',
    Municipality: 'Emfuleni',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '57%',
    ANC: '50',
    DA: '22',
    EEF: '11',
    IFP: '',
    'Other parties': '7',
    'Total council seats available': '90',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '55%',
  },
  {
    Province: 'GP',
    muni_code: 'GT422',
    Municipality: 'Midvaal',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '60%',
    ANC: '9',
    DA: '17',
    EEF: '2',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '29',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '66%',
  },
  {
    Province: 'GP',
    muni_code: 'GT423',
    Municipality: 'Lesedi',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '62%',
    ANC: '16',
    DA: '6',
    EEF: '3',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '26',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '64%',
  },
  {
    Province: 'GP',
    muni_code: 'GT481',
    Municipality: 'Mogale City',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '49%',
    ANC: '38',
    DA: '27',
    EEF: '9',
    IFP: '1',
    'Other parties': '2',
    'Total council seats available': '77',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '62%',
  },
  {
    Province: 'GP',
    muni_code: 'GT484',
    Municipality: 'Merafong City',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '55%',
    ANC: '30',
    DA: '12',
    EEF: '9',
    IFP: '1',
    'Other parties': '3',
    'Total council seats available': '55',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'GP',
    muni_code: 'GT485',
    Municipality: 'Rand West City',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '53%',
    ANC: '37',
    DA: '19',
    EEF: '8',
    IFP: '1',
    'Other parties': '4',
    'Total council seats available': '69',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '57%',
  },
  {
    Province: 'GP',
    muni_code: 'JHB',
    Municipality: 'City of Johannesburg',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '45%',
    ANC: '121',
    DA: '104',
    EEF: '30',
    IFP: '5',
    'Other parties': '10',
    'Total council seats available': '270',
    'Council run by': 'DA coalition then ANC coaltion',
    'Coalitions?': 'Yes',
    'Voter turnout': '57%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN212',
    Municipality: 'Umdoni',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '61%',
    ANC: '23',
    DA: '7',
    EEF: '1',
    IFP: '3',
    'Other parties': '3',
    'Total council seats available': '37',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN213',
    Municipality: 'Umzumbe',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '75%',
    ANC: '30',
    DA: '1',
    EEF: '1',
    IFP: '6',
    'Other parties': '1',
    'Total council seats available': '39',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '57%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN214',
    Municipality: 'UMuziwabantu',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '71%',
    ANC: '14',
    DA: '1',
    EEF: '1',
    IFP: '4',
    'Other parties': '0',
    'Total council seats available': '20',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '62%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN216',
    Municipality: 'Ray Nkonyeni',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '66%',
    ANC: '47',
    DA: '14',
    EEF: '2',
    IFP: '5',
    'Other parties': '3',
    'Total council seats available': '71',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '61%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN221',
    Municipality: 'uMshwathi',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '73%',
    ANC: '20',
    DA: '2',
    EEF: '1',
    IFP: '4',
    'Other parties': '0',
    'Total council seats available': '27',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '68%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN222',
    Municipality: 'uMngeni',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '56%',
    ANC: '13',
    DA: '10',
    EEF: '',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '23',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '68%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN223',
    Municipality: 'Mpofana',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '73%',
    ANC: '7',
    DA: '1',
    EEF: '',
    IFP: '1',
    'Other parties': '0',
    'Total council seats available': '9',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '64%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN224',
    Municipality: 'Impendle',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '89%',
    ANC: '6',
    DA: '',
    EEF: '',
    IFP: '1',
    'Other parties': '0',
    'Total council seats available': '7',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '69%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN225',
    Municipality: 'Msunduzi',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '67%',
    ANC: '52',
    DA: '15',
    EEF: '3',
    IFP: '5',
    'Other parties': '3',
    'Total council seats available': '78',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '67%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN226',
    Municipality: 'Mkhambathini',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '67%',
    ANC: '9',
    DA: '1',
    EEF: '1',
    IFP: '3',
    'Other parties': '0',
    'Total council seats available': '14',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '64%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN227',
    Municipality: 'Richmond',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '77%',
    ANC: '11',
    DA: '2',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '14',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN235',
    Municipality: 'Okhahlamba',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '54%',
    ANC: '15',
    DA: '2',
    EEF: '1',
    IFP: '7',
    'Other parties': '4',
    'Total council seats available': '29',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN237',
    Municipality: 'Inkosi Langalibalele (Estcourt/Loskop)',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '49%',
    ANC: '23',
    DA: '2',
    EEF: '1',
    IFP: '18',
    'Other parties': '2',
    'Total council seats available': '46',
    'Council run by': 'ANC coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '66%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN238',
    Municipality: 'Alfred Duma',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '63%',
    ANC: '46',
    DA: '4',
    EEF: '4',
    IFP: '16',
    'Other parties': '2',
    'Total council seats available': '72',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '62%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN241',
    Municipality: 'Endumeni',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '50%',
    ANC: '6',
    DA: '2',
    EEF: '1',
    IFP: '4',
    'Other parties': '0',
    'Total council seats available': '13',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN242',
    Municipality: 'Nquthu',
    'Party with the most votes in 2016': 'IFP',
    '% of votes cast for winning party': '45%',
    ANC: '14',
    DA: '1',
    EEF: '1',
    IFP: '15',
    'Other parties': '2',
    'Total council seats available': '33',
    'Council run by': 'IFP coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '58%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN244',
    Municipality: 'Msinga',
    'Party with the most votes in 2016': 'IFP',
    '% of votes cast for winning party': '66%',
    ANC: '12',
    DA: '',
    EEF: '',
    IFP: '24',
    'Other parties': '0',
    'Total council seats available': '36',
    'Council run by': 'IFP',
    'Coalitions?': 'No',
    'Voter turnout': '67%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN245',
    Municipality: 'Umvoti',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '54%',
    ANC: '15',
    DA: '1',
    EEF: '',
    IFP: '11',
    'Other parties': '0',
    'Total council seats available': '27',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '65%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN252',
    Municipality: 'Newcastle',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '62%',
    ANC: '41',
    DA: '6',
    EEF: '5',
    IFP: '11',
    'Other parties': '4',
    'Total council seats available': '67',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN253',
    Municipality: 'eMadlangeni',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '57%',
    ANC: '6',
    DA: '1',
    EEF: '1',
    IFP: '3',
    'Other parties': '0',
    'Total council seats available': '11',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '64%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN254',
    Municipality: 'Dannhauser',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '57%',
    ANC: '14',
    DA: '1',
    EEF: '1',
    IFP: '8',
    'Other parties': '1',
    'Total council seats available': '25',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN261',
    Municipality: 'eDumbe',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '51%',
    ANC: '8',
    DA: '5',
    EEF: '',
    IFP: '3',
    'Other parties': '0',
    'Total council seats available': '16',
    'Council run by': 'ANC/IFP coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '61%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN262',
    Municipality: 'UPhongolo',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '55%',
    ANC: '15',
    DA: '2',
    EEF: '1',
    IFP: '10',
    'Other parties': '1',
    'Total council seats available': '29',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN263',
    Municipality: 'Abaqulusi',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '47%',
    ANC: '21',
    DA: '3',
    EEF: '1',
    IFP: '19',
    'Other parties': '0',
    'Total council seats available': '44',
    'Council run by': 'IFP coalition/hung council',
    'Coalitions?': 'Yes',
    'Voter turnout': '56%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN265',
    Municipality: 'Nongoma',
    'Party with the most votes in 2016': 'IFP',
    '% of votes cast for winning party': '53%',
    ANC: '13',
    DA: '5',
    EEF: '2',
    IFP: '22',
    'Other parties': '0',
    'Total council seats available': '42',
    'Council run by': 'IFP',
    'Coalitions?': 'No',
    'Voter turnout': '58%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN266',
    Municipality: 'Ulundi',
    'Party with the most votes in 2016': 'IFP',
    '% of votes cast for winning party': '73%',
    ANC: '11',
    DA: '',
    EEF: '1',
    IFP: '35',
    'Other parties': '0',
    'Total council seats available': '47',
    'Council run by': 'IFP',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN271',
    Municipality: 'Umhlabuyalingana',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '61%',
    ANC: '22',
    DA: '1',
    EEF: '1',
    IFP: '10',
    'Other parties': '1',
    'Total council seats available': '35',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '64%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN272',
    Municipality: 'Jozini',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '48%',
    ANC: '19',
    DA: '1',
    EEF: '1',
    IFP: '18',
    'Other parties': '1',
    'Total council seats available': '40',
    'Council run by': 'IFP coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '64%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN275',
    Municipality: 'Mtubatuba',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '45%',
    ANC: '18',
    DA: '2',
    EEF: '1',
    IFP: '18',
    'Other parties': '1',
    'Total council seats available': '40',
    'Council run by': 'IFP coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '62%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN276',
    Municipality: 'Big 5 Hlabisa',
    'Party with the most votes in 2016': 'IFP',
    '% of votes cast for winning party': '52%',
    ANC: '11',
    DA: '1',
    EEF: '',
    IFP: '13',
    'Other parties': '0',
    'Total council seats available': '25',
    'Council run by': 'IFP',
    'Coalitions?': 'No',
    'Voter turnout': '64%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN281',
    Municipality: 'Mfolozi',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '50%',
    ANC: '17',
    DA: '',
    EEF: '1',
    IFP: '15',
    'Other parties': '0',
    'Total council seats available': '33',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '65%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN282',
    Municipality: 'uMhlathuze',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '64%',
    ANC: '43',
    DA: '8',
    EEF: '3',
    IFP: '13',
    'Other parties': '0',
    'Total council seats available': '67',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN284',
    Municipality: 'uMlalazi',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '55%',
    ANC: '30',
    DA: '1',
    EEF: '1',
    IFP: '22',
    'Other parties': '0',
    'Total council seats available': '54',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '63%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN285',
    Municipality: 'Mthonjaneni',
    'Party with the most votes in 2016': 'IFP',
    '% of votes cast for winning party': '56%',
    ANC: '10',
    DA: '',
    EEF: '1',
    IFP: '14',
    'Other parties': '0',
    'Total council seats available': '25',
    'Council run by': 'IFP',
    'Coalitions?': 'No',
    'Voter turnout': '63%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN286',
    Municipality: 'Nkandla',
    'Party with the most votes in 2016': 'IFP',
    '% of votes cast for winning party': '54%',
    ANC: '12',
    DA: '',
    EEF: '',
    IFP: '15',
    'Other parties': '0',
    'Total council seats available': '27',
    'Council run by': 'IFP',
    'Coalitions?': 'No',
    'Voter turnout': '66%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN291',
    Municipality: 'Mandeni',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '71%',
    ANC: '25',
    DA: '1',
    EEF: '1',
    IFP: '7',
    'Other parties': '1',
    'Total council seats available': '35',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '62%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN292',
    Municipality: 'KwaDukuza',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '64%',
    ANC: '36',
    DA: '11',
    EEF: '2',
    IFP: '4',
    'Other parties': '4',
    'Total council seats available': '57',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '67%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN293',
    Municipality: 'Ndwedwe',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '72%',
    ANC: '27',
    DA: '1',
    EEF: '1',
    IFP: '8',
    'Other parties': '0',
    'Total council seats available': '37',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '65%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN294',
    Municipality: 'Maphumulo',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '56%',
    ANC: '13',
    DA: '',
    EEF: '',
    IFP: '9',
    'Other parties': '0',
    'Total council seats available': '22',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '63%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN433',
    Municipality: 'Greater Kokstad',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '61%',
    ANC: '13',
    DA: '3',
    EEF: '2',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '19',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN434',
    Municipality: 'Ubuhlebezwe',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '73%',
    ANC: '20',
    DA: '1',
    EEF: '2',
    IFP: '2',
    'Other parties': '2',
    'Total council seats available': '27',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '64%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN435',
    Municipality: 'Umzimkhulu',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '86%',
    ANC: '38',
    DA: '1',
    EEF: '2',
    IFP: '1',
    'Other parties': '1',
    'Total council seats available': '43',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'KZN',
    muni_code: 'KZN436',
    Municipality: 'Dr Nkosasana Dlamini Zumu',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '78%',
    ANC: '23',
    DA: '3',
    EEF: '1',
    IFP: '2',
    'Other parties': '0',
    'Total council seats available': '29',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '66%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM331',
    Municipality: 'Greater Giyani',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '82%',
    ANC: '51',
    DA: '2',
    EEF: '5',
    IFP: '',
    'Other parties': '4',
    'Total council seats available': '62',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '55%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM332',
    Municipality: 'Greater Letaba',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '76%',
    ANC: '46',
    DA: '2',
    EEF: '9',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '60',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '52%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM333',
    Municipality: 'Greater Tzaneen',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '75%',
    ANC: '52',
    DA: '7',
    EEF: '8',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '69',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '52%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM334',
    Municipality: 'Ba-Phalaborwa',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '68%',
    ANC: '26',
    DA: '4',
    EEF: '6',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '37',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '51%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM335',
    Municipality: 'Maruleng',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '56%',
    ANC: '15',
    DA: '3',
    EEF: '5',
    IFP: '',
    'Other parties': '4',
    'Total council seats available': '27',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '56%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM341',
    Municipality: 'Musina',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '75%',
    ANC: '18',
    DA: '3',
    EEF: '3',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '24',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '55%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM343',
    Municipality: 'Thulamela',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '79%',
    ANC: '64',
    DA: '4',
    EEF: '8',
    IFP: '',
    'Other parties': '5',
    'Total council seats available': '81',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '46%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM344',
    Municipality: 'Makhado',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '75%',
    ANC: '56',
    DA: '9',
    EEF: '7',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '75',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '46%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM345',
    Municipality: 'Collins Chabane',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '85%',
    ANC: '60',
    DA: '2',
    EEF: '6',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '71',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '45%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM351',
    Municipality: 'Blouberg',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '74%',
    ANC: '33',
    DA: '2',
    EEF: '8',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '44',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '51%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM353',
    Municipality: 'Molemole',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '73%',
    ANC: '23',
    DA: '2',
    EEF: '7',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '32',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '52%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM354',
    Municipality: 'Polokwane',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '57%',
    ANC: '52',
    DA: '10',
    EEF: '26',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '90',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '52%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM355',
    Municipality: 'Lepele-Nkumpi',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '66%',
    ANC: '40',
    DA: '3',
    EEF: '15',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '60',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '50%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM361',
    Municipality: 'Thabazimbi',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '45%',
    ANC: '10',
    DA: '5',
    EEF: '5',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '23',
    'Council run by': "ANC coalition with Thabazimbi Resident's Council mayor",
    'Coalitions?': 'Yes',
    'Voter turnout': '51%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM362',
    Municipality: 'Lephalale',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '64%',
    ANC: '17',
    DA: '4',
    EEF: '5',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '26',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '50%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM366',
    Municipality: 'Bela-Bela',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '53%',
    ANC: '9',
    DA: '5',
    EEF: '2',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '17',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '55%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM367',
    Municipality: 'Mogalakwena',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '64%',
    ANC: '41',
    DA: '6',
    EEF: '13',
    IFP: '',
    'Other parties': '4',
    'Total council seats available': '64',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '49%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM368',
    Municipality: 'Modimolle/Mookgopong',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '48%',
    ANC: '13',
    DA: '7',
    EEF: '6',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '28',
    'Council run by': 'DA coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '58%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM471',
    Municipality: 'Ephraim Mogale',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '62%',
    ANC: '20',
    DA: '3',
    EEF: '7',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '32',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '50%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM472',
    Municipality: 'Elias Motsoaledi',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '66%',
    ANC: '41',
    DA: '5',
    EEF: '10',
    IFP: '',
    'Other parties': '5',
    'Total council seats available': '61',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '52%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM473',
    Municipality: 'Makhuduthamaga',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '68%',
    ANC: '43',
    DA: '2',
    EEF: '14',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '62',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '50%',
  },
  {
    Province: 'LP',
    muni_code: 'LIM476',
    Municipality: 'Fetakgomo Tubatse',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '69%',
    ANC: '54',
    DA: '4',
    EEF: '15',
    IFP: '',
    'Other parties': '4',
    'Total council seats available': '77',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '50%',
  },
  {
    Province: 'FS',
    muni_code: 'MAN',
    Municipality: 'Mangaung',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '57%',
    ANC: '58',
    DA: '27',
    EEF: '9',
    IFP: '',
    'Other parties': '6',
    'Total council seats available': '100',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '58%',
  },
  {
    Province: 'MP',
    muni_code: 'MP301',
    Municipality: 'Chief Albert Luthuli',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '84%',
    ANC: '41',
    DA: '2',
    EEF: '4',
    IFP: '1',
    'Other parties': '1',
    'Total council seats available': '49',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'MP',
    muni_code: 'MP302',
    Municipality: 'Msukaligwa',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '75%',
    ANC: '29',
    DA: '5',
    EEF: '3',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '38',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '57%',
  },
  {
    Province: 'MP',
    muni_code: 'MP303',
    Municipality: 'Mkhondo',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '77%',
    ANC: '29',
    DA: '4',
    EEF: '3',
    IFP: '1',
    'Other parties': '1',
    'Total council seats available': '38',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '57%',
  },
  {
    Province: 'MP',
    muni_code: 'MP304',
    Municipality: 'Dr Pixley Ka Isaka Seme',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '78%',
    ANC: '17',
    DA: '2',
    EEF: '1',
    IFP: '1',
    'Other parties': '0',
    'Total council seats available': '21',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'MP',
    muni_code: 'MP305',
    Municipality: 'Lekwa',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '68%',
    ANC: '20',
    DA: '5',
    EEF: '2',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '30',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '57%',
  },
  {
    Province: 'MP',
    muni_code: 'MP306',
    Municipality: 'Dipaleseng',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '76%',
    ANC: '9',
    DA: '2',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '12',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'MP',
    muni_code: 'MP307',
    Municipality: 'Govan Mbeki',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '57%',
    ANC: '36',
    DA: '15',
    EEF: '9',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '63',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'MP',
    muni_code: 'MP311',
    Municipality: 'Victor Khanye',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '65%',
    ANC: '11',
    DA: '4',
    EEF: '2',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '17',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '55%',
  },
  {
    Province: 'MP',
    muni_code: 'MP312',
    Municipality: 'Emalahleni',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '60%',
    ANC: '41',
    DA: '17',
    EEF: '8',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '68',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '51%',
  },
  {
    Province: 'MP',
    muni_code: 'MP313',
    Municipality: 'Steve Tshwete',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '56%',
    ANC: '32',
    DA: '17',
    EEF: '7',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '58',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '53%',
  },
  {
    Province: 'MP',
    muni_code: 'MP314',
    Municipality: 'Emakhazeni',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '70%',
    ANC: '11',
    DA: '3',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '15',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '56%',
  },
  {
    Province: 'MP',
    muni_code: 'MP315',
    Municipality: 'Thembisile Hani',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '76%',
    ANC: '49',
    DA: '3',
    EEF: '9',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '64',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '55%',
  },
  {
    Province: 'MP',
    muni_code: 'MP316',
    Municipality: 'Dr JS Moroka',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '69%',
    ANC: '43',
    DA: '4',
    EEF: '10',
    IFP: '',
    'Other parties': '5',
    'Total council seats available': '62',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '55%',
  },
  {
    Province: 'MP',
    muni_code: 'MP321',
    Municipality: 'Thaba Chweu',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '62%',
    ANC: '17',
    DA: '7',
    EEF: '2',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '27',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'MP',
    muni_code: 'MP324',
    Municipality: 'Nkomazi',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '83%',
    ANC: '54',
    DA: '4',
    EEF: '7',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '65',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '61%',
  },
  {
    Province: 'MP',
    muni_code: 'MP325',
    Municipality: 'Bushbuckridge',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '70%',
    ANC: '53',
    DA: '3',
    EEF: '4',
    IFP: '',
    'Other parties': '16',
    'Total council seats available': '76',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '54%',
  },
  {
    Province: 'MP',
    muni_code: 'MP326',
    Municipality: 'Mbombela',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '76%',
    ANC: '69',
    DA: '13',
    EEF: '6',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '90',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'NC',
    muni_code: 'NC061',
    Municipality: 'Richtersveld',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '53%',
    ANC: '4',
    DA: '3',
    EEF: '',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '7',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'NC',
    muni_code: 'NC062',
    Municipality: 'Nama Khoi',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '47%',
    ANC: '8',
    DA: '7',
    EEF: '',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '17',
    'Council run by': 'ANC coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '58%',
  },
  {
    Province: 'NC',
    muni_code: 'NC064',
    Municipality: 'Kamiesberg',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '63%',
    ANC: '4',
    DA: '2',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '7',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '68%',
  },
  {
    Province: 'NC',
    muni_code: 'NC065',
    Municipality: 'Hantam',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '49%',
    ANC: '5',
    DA: '4',
    EEF: '',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '9',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '66%',
  },
  {
    Province: 'NC',
    muni_code: 'NC066',
    Municipality: 'Karoo Hoogland',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '55%',
    ANC: '4',
    DA: '2',
    EEF: '',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '7',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '62%',
  },
  {
    Province: 'NC',
    muni_code: 'NC067',
    Municipality: 'Khai-Ma',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '58%',
    ANC: '4',
    DA: '2',
    EEF: '',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '7',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '58%',
  },
  {
    Province: 'NC',
    muni_code: 'NC071',
    Municipality: 'Ubuntu',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '43%',
    ANC: '3',
    DA: '2',
    EEF: '',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '7',
    'Council run by': 'ANC coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '67%',
  },
  {
    Province: 'NC',
    muni_code: 'NC072',
    Municipality: 'Umsobomvu',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '68%',
    ANC: '7',
    DA: '3',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '11',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '68%',
  },
  {
    Province: 'NC',
    muni_code: 'NC073',
    Municipality: 'Emthanjeni',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '58%',
    ANC: '9',
    DA: '5',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '15',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '63%',
  },
  {
    Province: 'NC',
    muni_code: 'NC074',
    Municipality: 'Kareeberg',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '47%',
    ANC: '4',
    DA: '2',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '7',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '66%',
  },
  {
    Province: 'NC',
    muni_code: 'NC075',
    Municipality: 'Renosterberg',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '52%',
    ANC: '4',
    DA: '3',
    EEF: '',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '7',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '70%',
  },
  {
    Province: 'NC',
    muni_code: 'NC076',
    Municipality: 'Thembelihle',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '55%',
    ANC: '4',
    DA: '2',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '7',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '65%',
  },
  {
    Province: 'NC',
    muni_code: 'NC077',
    Municipality: 'Siyathemba',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '60%',
    ANC: '6',
    DA: '3',
    EEF: '',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '9',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '65%',
  },
  {
    Province: 'NC',
    muni_code: 'NC078',
    Municipality: 'Siyancuma',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '58%',
    ANC: '8',
    DA: '3',
    EEF: '2',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '13',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '64%',
  },
  {
    Province: 'NC',
    muni_code: 'NC082',
    Municipality: 'Kai !Garib',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '58%',
    ANC: '11',
    DA: '5',
    EEF: '1',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '19',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '63%',
  },
  {
    Province: 'NC',
    muni_code: 'NC084',
    Municipality: '!Kheis',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '57%',
    ANC: '4',
    DA: '1',
    EEF: '',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '7',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '76%',
  },
  {
    Province: 'NC',
    muni_code: 'NC085',
    Municipality: 'Tsantsabane',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '55%',
    ANC: '7',
    DA: '2',
    EEF: '1',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '13',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '64%',
  },
  {
    Province: 'NC',
    muni_code: 'NC086',
    Municipality: 'Kgatelopele',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '45%',
    ANC: '3',
    DA: '2',
    EEF: '',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '7',
    'Council run by': 'DA coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '59%',
  },
  {
    Province: 'NC',
    muni_code: 'NC087',
    Municipality: 'Dawid Kruiper',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '59%',
    ANC: '18',
    DA: '10',
    EEF: '1',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '31',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '65%',
  },
  {
    Province: 'NC',
    muni_code: 'NC091',
    Municipality: 'Sol Plaatje',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '58%',
    ANC: '38',
    DA: '19',
    EEF: '5',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '65',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'NC',
    muni_code: 'NC092',
    Municipality: 'Dikgatlong',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '67%',
    ANC: '9',
    DA: '2',
    EEF: '2',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '13',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '61%',
  },
  {
    Province: 'NC',
    muni_code: 'NC093',
    Municipality: 'Magareng',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '61%',
    ANC: '5',
    DA: '2',
    EEF: '2',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '9',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'NC',
    muni_code: 'NC094',
    Municipality: 'Phokwane',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '62%',
    ANC: '12',
    DA: '3',
    EEF: '3',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '19',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'NC',
    muni_code: 'NC451',
    Municipality: 'Joe Morolong',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '71%',
    ANC: '21',
    DA: '1',
    EEF: '6',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '29',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '55%',
  },
  {
    Province: 'NC',
    muni_code: 'NC452',
    Municipality: 'Ga-Segonyana',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '65%',
    ANC: '18',
    DA: '3',
    EEF: '5',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '27',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '57%',
  },
  {
    Province: 'NC',
    muni_code: 'NC453',
    Municipality: 'Gamagara',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '49%',
    ANC: '7',
    DA: '5',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '13',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '57%',
  },
  {
    Province: 'EC',
    muni_code: 'NMA',
    Municipality: 'Nelson Mandela Bay',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '47%',
    ANC: '50',
    DA: '57',
    EEF: '6',
    IFP: '',
    'Other parties': '7',
    'Total council seats available': '120',
    'Council run by': 'DA coalition ',
    'Coalitions?': 'Yes',
    'Voter turnout': '64%',
  },
  {
    Province: 'NW',
    muni_code: 'NW371',
    Municipality: 'Moretele',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '71%',
    ANC: '38',
    DA: '4',
    EEF: '8',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '52',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '53%',
  },
  {
    Province: 'NW',
    muni_code: 'NW372',
    Municipality: 'Madibeng',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '54%',
    ANC: '45',
    DA: '16',
    EEF: '14',
    IFP: '',
    'Other parties': '6',
    'Total council seats available': '81',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '53%',
  },
  {
    Province: 'NW',
    muni_code: 'NW373',
    Municipality: 'Rustenburg',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '48%',
    ANC: '43',
    DA: '14',
    EEF: '24',
    IFP: '',
    'Other parties': '8',
    'Total council seats available': '89',
    'Council run by': 'ANC coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '50%',
  },
  {
    Province: 'NW',
    muni_code: 'NW374',
    Municipality: 'Kgetlengrivier',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '55%',
    ANC: '8',
    DA: '3',
    EEF: '3',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '15',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'NW',
    muni_code: 'NW375',
    Municipality: 'Moses Kotane',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '65%',
    ANC: '45',
    DA: '4',
    EEF: '15',
    IFP: '',
    'Other parties': '4',
    'Total council seats available': '68',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '52%',
  },
  {
    Province: 'NW',
    muni_code: 'NW381',
    Municipality: 'Ratlou',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '69%',
    ANC: '20',
    DA: '2',
    EEF: '3',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '28',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '53%',
  },
  {
    Province: 'NW',
    muni_code: 'NW382',
    Municipality: 'Tswaing',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '67%',
    ANC: '20',
    DA: '5',
    EEF: '3',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '29',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '51%',
  },
  {
    Province: 'NW',
    muni_code: 'NW383',
    Municipality: 'Mahikeng',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '60%',
    ANC: '43',
    DA: '7',
    EEF: '12',
    IFP: '',
    'Other parties': '7',
    'Total council seats available': '69',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '50%',
  },
  {
    Province: 'NW',
    muni_code: 'NW384',
    Municipality: 'Ditsobotla',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '61%',
    ANC: '25',
    DA: '7',
    EEF: '5',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '40',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '51%',
  },
  {
    Province: 'NW',
    muni_code: 'NW385',
    Municipality: 'Ramotshere Moiloa',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '60%',
    ANC: '23',
    DA: '2',
    EEF: '6',
    IFP: '',
    'Other parties': '7',
    'Total council seats available': '38',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '53%',
  },
  {
    Province: 'NW',
    muni_code: 'NW392',
    Municipality: 'Naledi',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '64%',
    ANC: '13',
    DA: '5',
    EEF: '2',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '20',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '56%',
  },
  {
    Province: 'NW',
    muni_code: 'NW393',
    Municipality: 'Mamusa',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '59%',
    ANC: '11',
    DA: '1',
    EEF: '2',
    IFP: '',
    'Other parties': '4',
    'Total council seats available': '18',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'NW',
    muni_code: 'NW394',
    Municipality: 'Greater Taung',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '67%',
    ANC: '34',
    DA: '2',
    EEF: '6',
    IFP: '',
    'Other parties': '6',
    'Total council seats available': '48',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '57%',
  },
  {
    Province: 'NW',
    muni_code: 'NW396',
    Municipality: 'Lekwa-Teemane',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '63%',
    ANC: '10',
    DA: '3',
    EEF: '1',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '16',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'NW',
    muni_code: 'NW397',
    Municipality: 'Kagisano-Molopo',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '74%',
    ANC: '22',
    DA: '2',
    EEF: '2',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '29',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '52%',
  },
  {
    Province: 'NW',
    muni_code: 'NW403',
    Municipality: 'Matlosana',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '60%',
    ANC: '46',
    DA: '17',
    EEF: '7',
    IFP: '',
    'Other parties': '7',
    'Total council seats available': '77',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '58%',
  },
  {
    Province: 'NW',
    muni_code: 'NW404',
    Municipality: 'Maquassi Hills',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '64%',
    ANC: '14',
    DA: '3',
    EEF: '2',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '22',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '57%',
  },
  {
    Province: 'NW',
    muni_code: 'NW405',
    Municipality: 'JB Marks',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '51%',
    ANC: '34',
    DA: '22',
    EEF: '5',
    IFP: '',
    'Other parties': '6',
    'Total council seats available': '67',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '58%',
  },
  {
    Province: 'GP',
    muni_code: 'TSH',
    Municipality: 'City of Tshwane',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '43%',
    ANC: '89',
    DA: '93',
    EEF: '25',
    IFP: '',
    'Other parties': '7',
    'Total council seats available': '214',
    'Council run by': 'DA coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '59%',
  },
  {
    Province: 'WC',
    muni_code: 'WC011',
    Municipality: 'Matzikama',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '55%',
    ANC: '5',
    DA: '8',
    EEF: '1',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '15',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'WC',
    muni_code: 'WC012',
    Municipality: 'Cederberg',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '56%',
    ANC: '4',
    DA: '6',
    EEF: '',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '11',
    'Council run by': 'ANC',
    'Coalitions?': 'No',
    'Voter turnout': '62%',
  },
  {
    Province: 'WC',
    muni_code: 'WC013',
    Municipality: 'Bergrivier',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '64%',
    ANC: '4',
    DA: '9',
    EEF: '',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '13',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '62%',
  },
  {
    Province: 'WC',
    muni_code: 'WC014',
    Municipality: 'Saldanha Bay',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '62%',
    ANC: '8',
    DA: '17',
    EEF: '1',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '27',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '64%',
  },
  {
    Province: 'WC',
    muni_code: 'WC015',
    Municipality: 'Swartland',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '70%',
    ANC: '6',
    DA: '16',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '23',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'WC',
    muni_code: 'WC022',
    Municipality: 'Witzenberg',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '46%',
    ANC: '8',
    DA: '11',
    EEF: '1',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '23',
    'Council run by': 'DA coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '52%',
  },
  {
    Province: 'WC',
    muni_code: 'WC023',
    Municipality: 'Drakenstein',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '66%',
    ANC: '15',
    DA: '43',
    EEF: '2',
    IFP: '',
    'Other parties': '5',
    'Total council seats available': '65',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '65%',
  },
  {
    Province: 'WC',
    muni_code: 'WC024',
    Municipality: 'Stellenbosch',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '69%',
    ANC: '8',
    DA: '30',
    EEF: '2',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '43',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '62%',
  },
  {
    Province: 'WC',
    muni_code: 'WC025',
    Municipality: 'Breede Valley',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '54%',
    ANC: '12',
    DA: '22',
    EEF: '1',
    IFP: '',
    'Other parties': '6',
    'Total council seats available': '41',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '60%',
  },
  {
    Province: 'WC',
    muni_code: 'WC026',
    Municipality: 'Langeberg',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '51%',
    ANC: '6',
    DA: '12',
    EEF: '1',
    IFP: '',
    'Other parties': '4',
    'Total council seats available': '23',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'WC',
    muni_code: 'WC031',
    Municipality: 'Theewaterskloof',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '52%',
    ANC: '10',
    DA: '14',
    EEF: '1',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '27',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '59%',
  },
  {
    Province: 'WC',
    muni_code: 'WC032',
    Municipality: 'Overstrand',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '65%',
    ANC: '8',
    DA: '16',
    EEF: '1',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '25',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '67%',
  },
  {
    Province: 'WC',
    muni_code: 'WC033',
    Municipality: 'Cape Agulhas',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '54%',
    ANC: '3',
    DA: '6',
    EEF: '',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '11',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '67%',
  },
  {
    Province: 'WC',
    muni_code: 'WC034',
    Municipality: 'Swellendam',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '48%',
    ANC: '5',
    DA: '6',
    EEF: '',
    IFP: '',
    'Other parties': '0',
    'Total council seats available': '11',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '66%',
  },
  {
    Province: 'WC',
    muni_code: 'WC041',
    Municipality: 'Kannaland',
    'Party with the most votes in 2016': 'ICOSA',
    '% of votes cast for winning party': '48%',
    ANC: '2',
    DA: '2',
    EEF: '',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '7',
    'Council run by': 'Icosa/ANC coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '70%',
  },
  {
    Province: 'WC',
    muni_code: 'WC042',
    Municipality: 'Hessequa',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '45%',
    ANC: '8',
    DA: '8',
    EEF: '',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '17',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '71%',
  },
  {
    Province: 'WC',
    muni_code: 'WC043',
    Municipality: 'Mossel Bay',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '61%',
    ANC: '7',
    DA: '17',
    EEF: '',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '27',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '64%',
  },
  {
    Province: 'WC',
    muni_code: 'WC044',
    Municipality: 'George',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '56%',
    ANC: '16',
    DA: '29',
    EEF: '1',
    IFP: '',
    'Other parties': '7',
    'Total council seats available': '53',
    'Council run by': 'DA',
    'Coalitions?': 'No',
    'Voter turnout': '61%',
  },
  {
    Province: 'WC',
    muni_code: 'WC045',
    Municipality: 'Oudtshoorn',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '56%',
    ANC: '7',
    DA: '14',
    EEF: '1',
    IFP: '',
    'Other parties': '3',
    'Total council seats available': '25',
    'Council run by': 'DA, then ANC coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '55%',
  },
  {
    Province: 'WC',
    muni_code: 'WC047',
    Municipality: 'Bitou',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '49%',
    ANC: '6',
    DA: '6',
    EEF: '',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '13',
    'Council run by': 'ANC coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '68%',
  },
  {
    Province: 'WC',
    muni_code: 'WC048',
    Municipality: 'Knysna',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '50%',
    ANC: '7',
    DA: '10',
    EEF: '',
    IFP: '',
    'Other parties': '4',
    'Total council seats available': '21',
    'Council run by': 'DA coalition, then ANC coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '64%',
  },
  {
    Province: 'WC',
    muni_code: 'WC051',
    Municipality: 'Laingsburg',
    'Party with the most votes in 2016': 'ANC',
    '% of votes cast for winning party': '46%',
    ANC: '3',
    DA: '3',
    EEF: '',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '7',
    'Council run by': 'DA coaltion, then ANC coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '71%',
  },
  {
    Province: 'WC',
    muni_code: 'WC052',
    Municipality: 'Prince Albert',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '34%',
    ANC: '2',
    DA: '3',
    EEF: '',
    IFP: '',
    'Other parties': '2',
    'Total council seats available': '7',
    'Council run by': 'DA coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '76%',
  },
  {
    Province: 'WC',
    muni_code: 'WC053',
    Municipality: 'Beaufort West',
    'Party with the most votes in 2016': 'DA',
    '% of votes cast for winning party': '49%',
    ANC: '6',
    DA: '6',
    EEF: '',
    IFP: '',
    'Other parties': '1',
    'Total council seats available': '13',
    'Council run by': 'DA coalition, then ANC coalition',
    'Coalitions?': 'Yes',
    'Voter turnout': '61%',
  },
  {
    Province: '',
    muni_code: '',
    Municipality: '',
    'Party with the most votes in 2016': '',
    '% of votes cast for winning party': '',
    ANC: '',
    DA: '',
    EEF: '',
    IFP: '',
    'Other parties': '',
    'Total council seats available': '',
    'Council run by': '',
    'Coalitions?': '',
    'Voter turnout': '',
  },
  {
    Province: '',
    muni_code: '',
    Municipality: 'Total seats',
    'Party with the most votes in 2016': '',
    '% of votes cast for winning party': '',
    ANC: '5163',
    DA: '1781',
    EEF: '761',
    IFP: '432',
    'Other parties': '508',
    'Total council seats available': '8645',
    'Council run by': '',
    'Coalitions?': '',
    'Voter turnout': '',
  },
  {
    Province: '',
    muni_code: '',
    Municipality: '% of total seats',
    'Party with the most votes in 2016': '',
    '% of votes cast for winning party': '',
    ANC: '59.72%',
    DA: '20.60%',
    EEF: '8.80%',
    IFP: '5.00%',
    'Other parties': '5.88%',
    'Total council seats available': '100.00%',
    'Council run by': '',
    'Coalitions?': '',
    'Voter turnout': '',
  },
  {
    Province: '',
    muni_code: '',
    Municipality: '',
    'Party with the most votes in 2016': '',
    '% of votes cast for winning party': '',
    ANC: '94.12%',
    DA: '',
    EEF: '',
    IFP: '',
    'Other parties': '',
    'Total council seats available': '',
    'Council run by': '',
    'Coalitions?': '',
    'Voter turnout': '',
  },
]

export { municipalData }
